import { CheckInContent } from '../../../features/survey/check-in-content/check-in-content';

const Home = () => {
  return (
    <div className="form-container flex min-h-0 flex-1 flex-col">
      <CheckInContent />
    </div>
  );
};

export { Home };
